import { VisorFirebaseService } from './../../services/visor-firebase.service';
import { Component, NgZone, OnInit } from '@angular/core';
import * as firebaseui from 'firebaseui';
import { Router } from '@angular/router';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {



  constructor(private visorFirebaseService: VisorFirebaseService,private router: Router,private ngZone: NgZone) { }

  ngOnInit(): void {


        this.visorFirebaseService.initAuthUi('#firebaseui-auth-container').subscribe(userl => {
          console.log("Tenemos usuario")
          this.gotoVisor();
        });
 }




  gotoVisor(){
    this.ngZone.run(()=>{
      this.router.navigate(['']);
    })

  }

}
